import React from 'react';

/**
 * PageBackground - Subtle grid pattern background
 *
 * Creates a professional trading terminal aesthetic with a subtle
 * indigo-tinted grid pattern behind all content.
 */
const PageBackground: React.FC = React.memo(() => {
  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{
        backgroundImage: `
          linear-gradient(rgba(20, 184, 166, 0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(20, 184, 166, 0.03) 1px, transparent 1px)
        `,
        backgroundSize: '60px 60px',
        zIndex: 0,
      }}
      aria-hidden="true"
    />
  );
});

PageBackground.displayName = 'PageBackground';

export default PageBackground;
